import {
  SupportTicket,
  TicketStatus,
  TicketPriority,
  TicketCategory,
  TicketComment,
  CustomerSatisfaction,
} from '../models/support-ticket.model';
import { RelatedEntityType } from '../models/notification.model';

export const MOCK_SUPPORT_TICKETS: SupportTicket[] = [
  {
    id: 1,
    ticketNumber: 'TICKET-2024-001',
    title: 'Unable to Access My Account',
    titleKey: 'support.unable-to-access-account',
    description:
      'I am unable to log into my resident portal. I keep getting an error message saying "Invalid credentials" even though I am using the correct password.',
    descriptionKey: 'support.unable-to-access-account-description',
    status: TicketStatus.OPEN,
    priority: TicketPriority.HIGH,
    category: TicketCategory.TECHNICAL,
    subcategory: 'Login Issues',
    assignedTo: 1,
    createdBy: 3,
    createdDate: new Date('2024-01-15T14:30:00Z'),
    updatedDate: new Date('2024-01-15T14:30:00Z'),
    dueDate: new Date('2024-01-17T14:30:00Z'),
    tags: ['login', 'account', 'access'],
    comments: [
      {
        id: 1,
        ticketId: 1,
        authorId: 3,
        content: 'I tried resetting my password but the reset email never arrived.',
        isInternal: false,
        isSystemGenerated: false,
        createdDate: new Date('2024-01-15T14:30:00Z'),
        updatedDate: new Date('2024-01-15T14:30:00Z'),
      },
      {
        id: 2,
        ticketId: 1,
        authorId: 1,
        content:
          "I have reset your password and sent a new temporary password to your email. Please check your spam folder if you don't see it in your inbox.",
        isInternal: false,
        isSystemGenerated: false,
        createdDate: new Date('2024-01-15T15:45:00Z'),
        updatedDate: new Date('2024-01-15T15:45:00Z'),
      },
    ],
    relatedEntityType: RelatedEntityType.USER,
    relatedEntityId: 3,
    isEscalated: false,
    slaBreach: false,
  },
  {
    id: 2,
    ticketNumber: 'TICKET-2024-002',
    title: 'Billing Discrepancy',
    titleKey: 'support.billing-discrepancy',
    description:
      'I was charged $200 for a service that should have been $150. The invoice shows the wrong amount and I need this corrected.',
    descriptionKey: 'support.billing-discrepancy-description',
    status: TicketStatus.IN_PROGRESS,
    priority: TicketPriority.MEDIUM,
    category: TicketCategory.BILLING,
    subcategory: 'Invoice Error',
    assignedTo: 2,
    createdBy: 4,
    createdDate: new Date('2024-01-14T10:15:00Z'),
    updatedDate: new Date('2024-01-16T09:20:00Z'),
    dueDate: new Date('2024-01-19T10:15:00Z'),
    tags: ['billing', 'invoice', 'discrepancy'],
    comments: [
      {
        id: 3,
        ticketId: 2,
        authorId: 4,
        content: 'I have attached the invoice and my payment receipt for reference.',
        isInternal: false,
        isSystemGenerated: false,
        createdDate: new Date('2024-01-14T10:15:00Z'),
        updatedDate: new Date('2024-01-14T10:15:00Z'),
      },
      {
        id: 4,
        ticketId: 2,
        authorId: 2,
        content:
          'I am reviewing the invoice and will get back to you within 24 hours with a resolution.',
        isInternal: false,
        isSystemGenerated: false,
        createdDate: new Date('2024-01-14T11:30:00Z'),
        updatedDate: new Date('2024-01-14T11:30:00Z'),
      },
    ],
    relatedEntityType: RelatedEntityType.INVOICE,
    relatedEntityId: 1,
    isEscalated: false,
    slaBreach: false,
  },
  {
    id: 3,
    ticketNumber: 'TICKET-2024-003',
    title: 'Feature Request: Mobile App',
    titleKey: 'support.feature-request-mobile-app',
    description:
      'It would be great to have a mobile app for residents to easily submit maintenance requests and check their account status on the go.',
    descriptionKey: 'support.feature-request-mobile-app-description',
    status: TicketStatus.PENDING_CUSTOMER,
    priority: TicketPriority.LOW,
    category: TicketCategory.FEATURE_REQUEST,
    subcategory: 'Mobile Application',
    assignedTo: 1,
    createdBy: 5,
    createdDate: new Date('2024-01-12T16:45:00Z'),
    updatedDate: new Date('2024-01-16T14:20:00Z'),
    dueDate: new Date('2024-01-26T16:45:00Z'),
    tags: ['feature', 'mobile', 'app', 'enhancement'],
    comments: [
      {
        id: 5,
        ticketId: 3,
        authorId: 5,
        content:
          'This would really improve the resident experience and make it easier to stay connected with the community.',
        isInternal: false,
        isSystemGenerated: false,
        createdDate: new Date('2024-01-12T16:45:00Z'),
        updatedDate: new Date('2024-01-12T16:45:00Z'),
      },
      {
        id: 6,
        ticketId: 3,
        authorId: 1,
        content:
          'Thank you for the suggestion! This is something we are considering for our roadmap. I will forward this to our development team for evaluation.',
        isInternal: false,
        isSystemGenerated: false,
        createdDate: new Date('2024-01-13T09:00:00Z'),
        updatedDate: new Date('2024-01-13T09:00:00Z'),
      },
    ],
    isEscalated: false,
    slaBreach: false,
  },
  {
    id: 4,
    ticketNumber: 'TICKET-2024-004',
    title: 'Bug Report: Calendar Not Loading',
    titleKey: 'support.bug-report-calendar-not-loading',
    description:
      'The community calendar is not loading properly. I see a blank page with just the header. This happens on both Chrome and Firefox browsers.',
    descriptionKey: 'support.bug-report-calendar-not-loading-description',
    status: TicketStatus.RESOLVED,
    priority: TicketPriority.MEDIUM,
    category: TicketCategory.BUG_REPORT,
    subcategory: 'Calendar Display',
    assignedTo: 1,
    createdBy: 2,
    createdDate: new Date('2024-01-10T11:20:00Z'),
    updatedDate: new Date('2024-01-12T15:30:00Z'),
    resolvedDate: new Date('2024-01-12T15:30:00Z'),
    actualResolutionTime: 2880,
    tags: ['bug', 'calendar', 'display', 'browser'],
    comments: [
      {
        id: 7,
        ticketId: 4,
        authorId: 2,
        content: 'I have tried clearing my browser cache and cookies but the issue persists.',
        isInternal: false,
        isSystemGenerated: false,
        createdDate: new Date('2024-01-10T11:20:00Z'),
        updatedDate: new Date('2024-01-10T11:20:00Z'),
      },
      {
        id: 8,
        ticketId: 4,
        authorId: 1,
        content:
          'I have identified and fixed the issue. It was related to a JavaScript error in the calendar component. The fix has been deployed and the calendar should now load properly.',
        isInternal: false,
        isSystemGenerated: false,
        createdDate: new Date('2024-01-12T15:30:00Z'),
        updatedDate: new Date('2024-01-12T15:30:00Z'),
      },
    ],
    customerSatisfaction: {
      id: 1,
      ticketId: 4,
      rating: 5,
      feedback: 'Great response time and the issue was resolved quickly. Thank you!',
      submittedDate: new Date('2024-01-13T10:00:00Z'),
      isAnonymous: false,
    },
    isEscalated: false,
    slaBreach: false,
  },
  {
    id: 5,
    ticketNumber: 'TICKET-2024-005',
    title: 'Security Concern: Suspicious Activity',
    titleKey: 'support.security-concern-suspicious-activity',
    description:
      "I noticed some suspicious activity in the building parking lot late at night. There were people I didn't recognize trying to access the building after hours.",
    descriptionKey: 'support.security-concern-suspicious-activity-description',
    status: TicketStatus.OPEN,
    priority: TicketPriority.CRITICAL,
    category: TicketCategory.SECURITY,
    subcategory: 'Suspicious Activity',
    assignedTo: 1,
    createdBy: 3,
    createdDate: new Date('2024-01-18T22:30:00Z'),
    updatedDate: new Date('2024-01-18T22:30:00Z'),
    dueDate: new Date('2024-01-19T22:30:00Z'),
    tags: ['security', 'suspicious', 'parking', 'after-hours'],
    comments: [
      {
        id: 9,
        ticketId: 5,
        authorId: 3,
        content:
          'This happened around 11:30 PM last night. I have security camera footage if needed.',
        isInternal: false,
        isSystemGenerated: false,
        createdDate: new Date('2024-01-18T22:30:00Z'),
        updatedDate: new Date('2024-01-18T22:30:00Z'),
      },
    ],
    isEscalated: true,
    escalationReason: 'Security concern requires immediate attention',
    escalationDate: new Date('2024-01-18T22:45:00Z'),
    slaBreach: false,
  },
];
